module.exports = __webpack_public_path__ + "img/logo8.bebe5916.png";